$mol_book2 $mol_scroll
	menu_title \
	sub /$mol_view
		^ pages <= pages_deep /$mol_view
		^ placeholders /$mol_view
			<= Placeholder $mol_view
	minimal_width 0
	Gap* $mol_view title \
